var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKitesurfomraade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.227,12.085a.794.794,0,0,1-.6-.273,1.392,1.392,0,0,0-2,0,.789.789,0,0,1-1.194,0,1.392,1.392,0,0,0-2,0,.793.793,0,0,1-1.2,0,1.4,1.4,0,0,0-2,0,.8.8,0,0,1-.6.273.308.308,0,1,0,0,.615,1.39,1.39,0,0,0,1-.424.791.791,0,0,1,1.2,0,1.395,1.395,0,0,0,2,0,.787.787,0,0,1,1.194,0,1.395,1.395,0,0,0,2,0,.785.785,0,0,1,1.191,0,1.384,1.384,0,0,0,1,.425.308.308,0,1,0,0-.615Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.609,10.632h.027l3.98-.521A.205.205,0,0,0,8.563,9.7l-.78.1a.2.2,0,0,0,0-.129l-.309-.734a.21.21,0,0,0-.057-.078l-.525-.44.069-.5.533-.348a.206.206,0,0,0,.1-.137l.123-.554,2.962-.142.006,0a.2.2,0,0,0,.063-.012A2.564,2.564,0,1,0,7.4,3.377a.144.144,0,0,0,0,.046c0,.011-.011.018-.011.03L7.35,6.662l-.131.593-.369.192c-.016-.006-.027-.023-.044-.025L6.67,7.406A.394.394,0,1,0,6.178,7.1a.388.388,0,0,0,.163.256c.02.014.045.011.066.021l-.164-.019c-.019,0-.034.011-.053.015L5.9,7.144l-.055-.559A.215.215,0,0,0,5.624,6.4a.205.205,0,0,0-.184.224l.063.647a.207.207,0,0,0,.078.141l.387.391-.063.642c0,.008.007.015.007.023s-.008.012-.007.02l.066.715-.5.728a.192.192,0,0,0-.016.177l-.876.115a.2.2,0,0,0,.026.408ZM7.8,3.6a2.144,2.144,0,0,1,2.727,2.734l-2.761.133ZM6.351,9.374a.206.206,0,0,0,.035-.134l.02-.536.177.035.531.407.29.688c0,.009.014.011.018.018l-1.534.2Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitesurfomraade);
export default __webpack_public_path__ + "static/media/KITESURFOMRAADE.748af4c2ea7d2cd07f38931cc420290c.svg";
export { ForwardRef as ReactComponent };